import MUIButton from '@/components/MUI-Components/MUI-Button';
import MUIDialog from '@/components/MUI-Components/MUI-Dialog';
import React, {Fragment, useState, memo} from 'react';
import OpportunityDetails from '@/components/Ui-components/opportunityDetails';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

const seoExecutive = [
    'Proficient with SEO tools (Google Analytics, Search Console, Ahrefs, Moz, etc.)',
    'Basic knowledge of HTML, CSS, and website structure for SEO optimization',
    'Strong written and verbal communication skills',
    'Detail-oriented, with multitasking and prioritization abilities',
    'Analytical mindset with a proactive approach Perform keyword research to target relevant search terms',
    'Execute off-page SEO and link-building strategies',
    'Monitor website performance and provide data-driven SEO recommendations',
    'Stay updated on SEO trends, algorithm changes, and best practices',
    'Generate performance reports highlighting key metrics and growth'
];

export const leadGenerationDescription = [
    'Generate qualified leads via calls, emails, and LinkedIn.',
    'Research target accounts and identify key decision-makers.',
    'Schedule meetings for the sales team.',
    'Update and manage leads in CRM (HubSpot/Salesforce).',
    'Achieve monthly/quarterly lead generation targets.',
    '2–4 years of lead generation experience.',
    'Excellent communication skills.',
    'Familiar with tools like LinkedIn Sales Navigator, Mailchimp, etc.',
    'Experience running lead gen campaigns.',
    'Strong CRM knowledge and prospect engagement skills.'
];

export const writerDescription = [
    'Identify and analyze RFPs from private US/UK companies',
    'Draft compelling proposals and ensure timely submissions',
    'Collaborate with tech teams to align solutions with client needs',
    'Generate leads, pitch software services, and close deals',
    'Track market trends and tailor strategies for business growth',
    'Maintain strong client relationships and manage end-to-end sales cycles',
    '5+ years in RFP writing and software sales',
    'Proven success in winning RFPs',
    'Strong communication, negotiation & client engagement skills',
    'Knowledge of US private-sector procurement',
    'Familiarity with AI, blockchain, cloud tech (preferred)'
];

export const businessDescription = [
    'Identify and close new business opportunities in web/mobile app development',
    'Understand client requirements and deliver tailored solutions',
    'Conduct meetings, demos, and negotiations with international clients',
    'Collaborate with internal teams to create proposals, scope, and pricing',
    'Meet and exceed assigned sales targets',
    'Experience in international sales and B2B client handling',
    'Strong communication, presentation, and negotiation skills',
    'Familiarity with CRM tools (HubSpot, Zoho, Salesforce, etc.)',
    'Knowledge of sales pipeline management and market research',
    'Understanding of IT services, project lifecycle, and emerging tech',
    'Professional, self-driven, and target-oriented approach'
];

const opportunityData = [
    {
        vacancies: '2',
        label: 'SEO Executive',
        experience: '1 - 2',
        description: seoExecutive,
        qualification: 'BCA, MCA, B.Tech'
    },
    {
        label: 'Lead Generation Specialist',
        vacancies: '1',
        qualification: 'BBA/B.Tech, MBA',
        experience: '2 - 4',
        description: leadGenerationDescription
    },
    {
        label: 'RFP Writer & Sales Specialist',
        qualification: 'B.E./MBA or equivalent',
        vacancies: '1',
        experience: '5+',
        description: writerDescription
    },
    {
        label: 'Business Development Executive',
        qualification: 'BBA/B.Tech, MBA',
        experience: '3 - 4',
        vacancies: '1',
        description: businessDescription
    }
];

const Opportunity = (props: any) => {
    const [open, setOpen] = useState<any>(false);
    const [jobData, setJobData] = useState();

    const handleClickOpenDetails = (opportunity: any) => {
        setOpen(true);
        setJobData(opportunity);
    };
    const handleClose = () => {
        setOpen(false);
    };
    const {button} = props;
    return (
        <Box className="opportunity-deatils-main">
            <Box className="spectrum-header-wrapper solutions top-space">
                <Typography className="spectrum-heading color-black ">Your Next Opportunity Awaits! Realize Your Potential…</Typography>

                <Box className="divder-wrapper">
                    <hr className="divider-line" />
                </Box>
                <Box className="sub-heading-box ">
                    <Typography className="spectrum-sub-heading color-black">
                        We’re growing at a rate of knots and are actively on the lookout for talented and tech driven professionals to help
                        us push the frontiers of mobile technology to develop & deliver innovative, next-gen products and services. Check
                        out our current openings:
                    </Typography>
                </Box>
            </Box>
            <Box className="opportunity-stack">
                <Grid container spacing={2} className="top-spacing">
                    {opportunityData?.map((opportunity: any, index: number) => (
                        <Fragment key={index}>
                            <Grid item xs={12} md={6}>
                                <Box className="opportunity-box">
                                    <Box className="opportunity-content">
                                        <Typography className="opportunity-heading color-black ">{opportunity.label}</Typography>
                                        <Typography className="opportunity-sub-heading ">
                                            Vacancies: <span>{opportunity.vacancies}</span>
                                        </Typography>
                                    </Box>
                                    <Box className=" banner-contact-btn">
                                        <MUIButton
                                            className="opportunity-button"
                                            variant="outlined"
                                            label={button}
                                            onClick={() => handleClickOpenDetails(opportunity)}
                                        />
                                    </Box>
                                </Box>
                            </Grid>
                        </Fragment>
                    ))}
                </Grid>
            </Box>
            <MUIDialog open={open} handleClose={handleClose} className="career-modal-form-wrapper" maxWidth="md">
                <OpportunityDetails jobData={jobData} handleClose={handleClose} fullWidth={true} />
            </MUIDialog>
        </Box>
    );
};

export default memo(Opportunity);
